define('lq/events/actions/raiseEvent',[
        'lq/events/actions/eventAction',
        'jquery'
], function (EventAction, $) {
    'use strict';

    function RaiseEvent(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(RaiseEvent, EventAction);

    RaiseEvent.typeName = 'RaiseEvent';

    RaiseEvent.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    RaiseEvent.prototype.execute = function (continuation, eventActionResponse) {            
        if (this.eventData.eventReceiver) {
            var drop = this.piping.dropFactory.findDropById(this.eventData.eventReceiver);

            if (drop) {
                var eventObj = {
                    eventName: this.eventData.eventName,
                    args: [this.getEventValue()]
                };
                drop.triggerEventForChild(eventObj);
            }

            continuation();
        } else if (this.piping.eventing.hasSubscribers(this.eventData.eventName)) {
            this.piping.eventing.publish(this.eventData.eventName, this.eventSource, this.getEventValue(), continuation);
        } else {
            if (window.console && window.console.log) {
                window.console.log('Event "' + this.eventData.eventName + '" is not catched anywhere on the current Action, it might still be caught through a ModalAction though.');
            }
            this.piping.eventing.publish(this.eventData.eventName, this.eventSource, this.getEventValue()); //for now trigger this event anyway, because it might be caught via a ModalAction
            continuation();
        }
    };

    RaiseEvent.prototype.getEventValue = function () {
        if (this.eventData.eventParameter)
            return this.piping.parameters.getValue(this.eventData.eventParameter);
        return null;
    };

    return RaiseEvent;
});
